<template>
  <v-layout
    column
    fill-height
  >
    <v-flex
      xs12
      class="none-growth"
    >
      <v-layout justify-end>
        <v-flex shrink>
          <AppLogout />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <router-view />
    </v-flex>
    <leaveConfirmDialog ref="confirm" />
  </v-layout>
</template>

<script>
import AppLogout from '@/components/widgets/menu/AppLogout';
import LeaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';

export default {
    name: 'AddFamilyPage',
    components: { LeaveConfirmDialog, AppLogout },
    inject: ['$validator'],
    beforeRouteEnter (to, from, next) {
        if (from.name === null && to.name !== 'family-consent') {
            next({ name: 'family-consent' });
        } else {
            next();
        }
    },
    beforeRouteLeave (to, from, next) {
        if (
            this.isFormEmpty &&
      !this.$store.getters['token/isForcedToLogout'] &&
      this.$route.name !== 'family-summary'
        ) {
            this.$refs.confirm.dialog = true;
            this.$refs.confirm.open().then((confirm) => {
                if (confirm) {
                    this.$store.commit('familyData/clearFormData');
                    this.$store.commit('familyData/setSimilarityParameters', null);
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            this.$store.commit('familyData/clearFormData');
            this.$store.commit('familyData/setSimilarityParameters', null);
            next();
        }
    },
    computed: {
        isFormEmpty () {
            return this.$store.getters['familyData/getConsentFiles'].length > 0;
        },
        routeName () {
            return this.$route.name !== 'family-details';
        },
        formFields () {
            return this.$validator._base.fields.items;
        }
    }
};
</script>

<style scoped></style>
